import { useAuthController } from "@firecms/core";
import { Button } from "@firecms/ui";
import { useState } from "react";

import { CONNECT_LINK_GENERATE_ROLES, hasAnyRole } from "./apple_grant_status.roles";
import { ConnectLinkDialog } from "./ConnectLinkDialog";

/**
 * Toolbar action on the Apple Business Connect list: generate a connect link for a client who is
 * NOT in the list yet.
 *
 * The list only ever contains clients who have already linked — the backend writes the projection on
 * OAuth callback — so the list alone can never serve the case staff actually need. This button is
 * that case, and it is the reason the surface is one nav item rather than two collections.
 *
 * Rendered only for roles in `CONNECT_LINK_GENERATE_ROLES`; a viewer without them sees the list and
 * no button.
 */
export function GenerateConnectLinkAction() {
  const authController = useAuthController();
  const [open, setOpen] = useState(false);

  if (!hasAnyRole(authController, CONNECT_LINK_GENERATE_ROLES)) return null;

  return (
    <>
      <Button onClick={() => setOpen(true)} color="primary" variant="text">
        Generate connect link
      </Button>
      <ConnectLinkDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
